import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { CounterStrip } from '@/components/shared/counterStrip';
interface ResourceSelectionManualViewerProps {
  include: string[];
  exclude: string[];
}
export const ResourceSelectionManualViewer = t0 => {
  const $ = _c(10);
  const {
    include,
    exclude
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "100%",
      gap: "24px"
    };
    t2 = <Typography variant="h4">Manual overrides</Typography>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: "12px",
      width: "240px"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== include.length) {
    t4 = <CounterStrip label="Included resources" count={include.length} />;
    $[3] = include.length;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== exclude.length) {
    t5 = <CounterStrip label="Excluded resources" count={exclude.length} />;
    $[5] = exclude.length;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <Stack sx={t1}>{t2}<Stack sx={t3}>{t4}{t5}</Stack></Stack>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};